// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"09811a6c","990":"19de7b4f"}[chunkId] + ".chunk.css";
};